import { render, staticRenderFns } from "./RoomItem.vue?vue&type=template&id=cbe41ce2&"
import script from "./RoomItem.vue?vue&type=script&lang=ts&"
export * from "./RoomItem.vue?vue&type=script&lang=ts&"
import style0 from "./RoomItem.vue?vue&type=style&index=0&id=cbe41ce2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports